module.exports = __webpack_public_path__ + "img/vitamind-plus-premium.4c865242.jpg";